module.exports = __webpack_public_path__ + "static/media/app-store-badge.eaf5cd69.svg";